import * as authActions from './actions';

const initialState = {
  adminUser: {
    isAuthenticated: false,
    token: null,
    firstName: null,
    lastName: null,
    roleName: null,
    expiry: null,
    loading: false,
    error: null,
    // Freshness timestamp for `error` — bumped on every AUTH_FAIL via Date.now().
    // Login.js's toast effect depends on this so it re-fires even when the
    // backend returns the same error string twice in a row (local React state
    // like submitNonce gets reset when Login remounts mid-submit; Redux state
    // survives the remount). Null on a clean app boot and on every success.
    errorAt: null,
    language: null,
    selectedCountry: 'ALL'
  },
};

export const authReducers = (state = initialState, action) => {
  switch (action.type) {
    case authActions.AUTH_START: {
      return {
        ...initialState,
        adminUser: {
          ...initialState.adminUser,
          loading: true,
          language: state.adminUser.language,
          selectedCountry: state.adminUser.selectedCountry
        },
      };
    }
    case authActions.AUTH_SUCCESS: {
      const newTimer = Date.now();  
      localStorage.setItem("lastUserActivity", newTimer);
      const adminUser = {
        isAuthenticated: true,
        isBasicProfile: false,
        token: action.user.token,
        userId: action.user.id,
        role: action.user.role.replaceAll('"',""),
        firstName: action.user.firstName,
        lastName: action.user.lastName,
        roleName: action.user.roleName,
        language: state.adminUser.language,
        selectedCountry: state.adminUser.selectedCountry,
        apiToken: action.user.apiToken,
        email: action.user.email,
        phoneNumber: action.user.phoneNumber,
        loading: false,
        error: null,
        errorAt: null,
      };
      return { ...state, adminUser };
    }

    case authActions.AUTH_SUCCESS_LAST_STEP: {
      const adminUser = {
        isAuthenticated: true,
        isBasicProfile: true,
        token: action.user.token,
        userId: action.user.id,
        phoneNumber: action.user.phoneNumber,
        email: action.user.email,
        language: state.adminUser.language,
        selectedCountry: state.adminUser.selectedCountry,
        loading: false,
        error: null,
        apiToken: action.user.apiToken,
      };
      return { ...state, adminUser };
    }

    case authActions.AUTH_SUCCESS_MOBILE_STEP: {
      const adminUser = {
        isAuthenticated: false,
        loading: false,
        error: null,
        phoneNumber: action.user.phoneNumber,
        language: state.adminUser.language,
        selectedCountry: state.adminUser.selectedCountry
      };
      return { ...state, adminUser };
    }

    case authActions.AUTH_BASIC_PROFILE_SUCCESS: {
      // Guard role against undefined: the basic-profile submit response is `{}`
      // (users.controller.js:456), so `action.user.role` is undefined and the
      // bare `.replaceAll` threw. The throw bubbled into authBasicProfile's
      // catch → authFail → AUTH_FAIL → full state wipe (token/apiToken/userId
      // all reset to initialState). Fall back to the role already in Redux,
      // which was set during the login that landed the user here.
      const safeRole = action.user.role
        ? action.user.role.replaceAll('"', '')
        : state.adminUser.role;
      const adminUser = {
        isAuthenticated: true,
        userId: action.user.id,
        role: safeRole,
        isBasicProfile: false,
        language: state.adminUser.language,
        selectedCountry: state.adminUser.selectedCountry,
        loading: false,
        error: null,
        apiToken: action.user.apiToken,
      };
      return { ...state, adminUser };
    }

    case authActions.LANGUAGE_CHANGE: {
      const adminUser = {
        ...state.adminUser,
       language: action.user
      };
      return { ...state, adminUser };
    }

    case authActions.LANGUAGE_CHANGE_NAVBAR: {
      return {
        adminUser: {
          ...state.adminUser,
          language: action.user,
        },
      };
    }

    case authActions.COUNTRY_CHANGE: {
      return {
        adminUser: {
          ...state.adminUser,
          selectedCountry: action.payload,
        },
      };
    }

    case authActions.AUTH_REGISTRATION_SUCCESS: {
      const adminUser = {
        isAuthenticated: false,
        loading: false,
        language: state.adminUser.language,
        selectedCountry: state.adminUser.selectedCountry,
        error: null,
      };
      return { ...state, adminUser };
    }
    case authActions.AUTH_FAIL: {
      return {
        ...initialState,
        adminUser: {
          ...initialState.adminUser,
          error: action.error,
          // Freshness timestamp — Date.now() yields a new number on every
          // failed attempt, so Login.js's useEffect re-fires the toast even
          // when the error string is identical to the previous attempt.
          errorAt: Date.now(),
          language: state.adminUser.language,
          selectedCountry: state.adminUser.selectedCountry,
        },
      };
    }
    default: {
      return state;
    }
  }
};
